// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"4121":"589c4fac92066bed","6947":"e17415dc043f6148","8944":"17acbcacc8e1f2c8"}[chunkId] + ".css";
};